import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { CollectionItem } from '../types'
import { getCollection, deleteCollectionItem, updateCollectionItem } from '../utils/storage'
import styles from './Collection.module.css'

const conditionLabels: Record<string, string> = {
  new: '新品',
  like_new: '未使用に近い',
  good: '良好',
  fair: 'やや難あり',
  poor: '難あり',
}

const categoryLabels: Record<string, string> = {
  acrylic: 'アクスタ',
  penlight: 'ペンライト',
  photo: '写真',
  towel: 'タオル',
  tshirt: 'Tシャツ',
  other: 'その他',
}

export default function Collection() {
  const [items, setItems] = useState<CollectionItem[]>([])
  const [filter, setFilter] = useState<'all' | 'tradeable'>('all')

  useEffect(() => {
    setItems(getCollection())
  }, [])

  const handleDelete = (id: string) => {
    if (window.confirm('削除しますか？')) {
      deleteCollectionItem(id)
      setItems(getCollection())
    }
  }

  const handleToggleTrade = (id: string, current: boolean) => {
    updateCollectionItem(id, { isTradeAvailable: !current })
    setItems(getCollection())
  }

  const filteredItems = filter === 'tradeable'
    ? items.filter(item => item.isTradeAvailable)
    : items

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>マイコレクション</h1>
        <Link to="/collection/add" className={styles.addButton}>
          追加
        </Link>
      </div>

      <div className={styles.filters}>
        <button
          className={`${styles.filterButton} ${filter === 'all' ? styles.active : ''}`}
          onClick={() => setFilter('all')}
        >
          すべて ({items.length})
        </button>
        <button
          className={`${styles.filterButton} ${filter === 'tradeable' ? styles.active : ''}`}
          onClick={() => setFilter('tradeable')}
        >
          交換可 ({items.filter(i => i.isTradeAvailable).length})
        </button>
      </div>

      {filteredItems.length === 0 ? (
        <p className={styles.empty}>
          {filter === 'tradeable' ? '交換可能なアイテムがありません' : 'コレクションがありません'}
        </p>
      ) : (
        <div className={styles.list}>
          {filteredItems.map(item => (
            <div key={item.id} className={styles.item}>
              <Link to={`/collection/${item.id}`} className={styles.itemLink}>
                <div className={styles.itemImage}>
                  <img
                    src={item.imageUrl || 'https://placehold.co/80x80?text=No+Image'}
                    alt={item.title}
                  />
                </div>
                <div className={styles.itemInfo}>
                  <p className={styles.itemTitle}>{item.title}</p>
                  <p className={styles.itemMeta}>
                    {categoryLabels[item.category] || item.category}
                    {item.artist && ` / ${item.artist}`}
                  </p>
                  <p className={styles.itemCondition}>
                    {conditionLabels[item.condition]}
                  </p>
                  {item.wantedItems && item.wantedItems.length > 0 && (
                    <p className={styles.itemWanted}>
                      交換希望: {item.wantedItems.join(', ')}
                    </p>
                  )}
                </div>
              </Link>
              <div className={styles.itemActions}>
                <button
                  className={`${styles.tradeButton} ${item.isTradeAvailable ? styles.tradeable : ''}`}
                  onClick={() => handleToggleTrade(item.id, item.isTradeAvailable)}
                >
                  {item.isTradeAvailable ? '交換可' : '交換不可'}
                </button>
                <button
                  className={styles.deleteButton}
                  onClick={() => handleDelete(item.id)}
                >
                  削除
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
